/** Mismos valores por defecto que `backend/src/constants/defaultMessagingSettings.ts`. */

export const DEFAULT_USER_RATING_MESSAGE_TEXT =
  "Escribe de 1 a 3 para valorar nuestra atención:\n" +
  "*1* - _Insatisfecho_\n" +
  "*2* - _Satisfecho_\n" +
  "*3* - _Muy satisfecho_\n";

export const DEFAULT_SEND_GREETING_ACCEPTED_MESSAGE_TEXT =
  "¡Hola {{name}}! Gracias por contactarnos. A continuación verás las opciones disponibles.";

export const DEFAULT_TRANSFER_TICKET_MESSAGE_TEXT =
  "¡Hola {{name}}! 👋\n\n" +
  "Has sido transferido al departamento de *{queueName}*.\n\n" +
  "En breve te atenderemos.";

export const DEFAULT_SEND_GREETING_ONE_QUEUE_MESSAGE_TEXT =
  "¡Hola {{name}}! Gracias por escribirnos. En un momento te atendemos.";
